import styled from 'styled-components'

const Container = styled.span`
  display: flex;
  flex-direction: row;
  /*justify-content: ${props => (props.justify === 'right') ? 'flex-end' : 'flex-start'};*/
  justify-content: space-around;
  flex: none;
  padding: 0 1.5rem;
  padding-left: ${props => (props.justify === 'right') ? '1.5rem' : '0.5rem'};
  padding-right: ${props => (props.justify === 'right') ? '0.5rem' : '1.5rem'};
  min-width: 5rem;
`

export default function IconContainer({children, justify, style}) {
  return (
    <Container
      justify={justify}
      style={style}
    >
      {children}
    </Container>
  );
}
